import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import "pdfjs-dist/build/pdf.worker.entry";
import "./PdfDetails.css";
import axios from "axios";

const PdfDetails = () => {
  const { pdfItem } = useLocation().state || {};
  const [pdfImages, setPdfImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);
  const [imagesPerRow, setImagesPerRow] = useState(3); // Default to show 3 images per row
  const [showAsImages, setShowAsImages] = useState(true); // default to show watermarked images


  // console.log(pdfItem);
  
  // Function to fetch the setting
  const fetchSetting = () => {
    axios.post('https://api.notesmania.in/settings.php', { name: 'pdf-view' })
      .then(res => {
        if (res.data.status === 'success') {
          // Map API response to boolean state (1 = false, 0 = true)
          // setShowAsImages(res.data.value === 0); 
          console.log(res.data);
          setShowAsImages(res.data.value === 0)
          
        }
      })
      .catch((error) => console.error("Error fetching setting:", error));
  };


  const addWatermark = (context, canvas) => {
    const text = "NOTESMANIA";
    context.font = "20px Arial";
    context.fillStyle = "rgba(255, 0, 0, 0.1)";
    context.textAlign = "center";
    context.textBaseline = "middle";

    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;

    context.save();
    context.translate(centerX, centerY);
    context.rotate(-Math.PI / 7);
    for (let y = -canvas.height; y < canvas.height; y += 100) {
      for (let x = -canvas.width; x < canvas.width * 2; x += 300) {
        context.fillText(text, x, y);
      }
    }
    context.restore();
  };

  useEffect(() => {
    fetchSetting(); // First fetch the setting
  }, [pdfItem]);
  
  useEffect(() => {
    if (pdfItem && pdfItem.file_path && showAsImages === true) {
      const pdfUrl = `https://api.notesmania.in/serve-pdf.php?file=${encodeURIComponent(pdfItem.file_path)}`;
      renderPdfAsImagesWithWatermark(pdfUrl);
    } else {
      setLoading(false); // Stop loading if we're not rendering images
    }
  }, [pdfItem, showAsImages]);
  

  const renderPdfAsImagesWithWatermark = async (url) => {
    try {
      const loadingTask = pdfjsLib.getDocument(url);
      const pdf = await loadingTask.promise;
  
      const images = [];
      for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
        const page = await pdf.getPage(pageNumber);
        const scale = 4.0; // Higher scale for ultra-high resolution
        const viewport = page.getViewport({ scale });
  
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
  
        // Support high DPI screens
        const outputScale = window.devicePixelRatio || 1;
        canvas.width = Math.floor(viewport.width * outputScale);
        canvas.height = Math.floor(viewport.height * outputScale);
        context.scale(outputScale, outputScale);
  
        const renderContext = { canvasContext: context, viewport: viewport };
        await page.render(renderContext).promise;
  
        addWatermark(context, canvas);
  
        // Convert to Blob for highest quality
        const imageUrl = await new Promise((resolve) => {
          canvas.toBlob((blob) => {
            resolve(URL.createObjectURL(blob));
          }, "image/png", 1.0);
        });
  
        images.push(imageUrl);
        setProgress(Math.round((pageNumber / pdf.numPages) * 100));
      }
  
      setPdfImages(images);
      setLoading(false);
    } catch (error) {
      console.error("Error rendering PDF:", error);
      setLoading(false);
    }
  };
  const handleImagesPerRowChange = (event) => {
    const value = Number(event.target.value);
    setImagesPerRow(value);
  };

  if (!pdfItem) {
    return <div>No PDF data available</div>;
  }

  return (
    <div className="pdf-details-container">
      {/* User Profile Section */}
      <div className="user-profile">

        <div className="user-info">
          <h2>{pdfItem.username}</h2>
          <p>{pdfItem.college}</p>
  
      </div>
</div>

      {/* PDF Metadata Section */}
      <div className="pdf-metadata">
        <div className="metadata-item">
          <strong>Category:</strong>
          <span>{pdfItem.category}</span>
        </div>
        <div className="metadata-item">
          <strong>Course:</strong>
          <span>{pdfItem.course}</span>
        </div>
        <div className="metadata-item">
          <strong>Semester:</strong>
          <span>{pdfItem.semester}</span>
        </div>
        <div className="metadata-item">
          <strong>Subject:</strong>
          <span>{pdfItem.subject}</span>
        </div>
        <div className="metadata-item">
          <strong>Tags:</strong>
          <span>{pdfItem.tags}</span>
        </div>
      </div>

      {/* Pages per row Dropdown */}
      {/* <div className="page-selection">
        <label htmlFor="imagesPerRow">Select Images Per Row: </label>
        <select
          id="imagesPerRow"
          value={imagesPerRow}
          onChange={handleImagesPerRowChange}
        >
          <option value={1}>1</option>
          <option value={2}>2</option>
          <option value={3}>3</option>
          <option value={4}>4</option>
          <option value={5}>5</option>
        </select>
      </div> */}
      <div className="page-selection">
        <div className="page-selection-under-1">
          <label htmlFor="imagesPerRow">Select Images Per Row: </label>

        </div>
        <div className="page-selection-under-2">
  {[1, 2, 3, 4, 5].map((value) => (
    <button
      key={value}
      className={`icon-button ${imagesPerRow === value ? 'active' : ''}`}
      onClick={() => handleImagesPerRowChange({ target: { value } })}
      aria-label={`Set ${value} images per row`}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {Array(value)
          .fill(null)
          .map((_, rowIndex) => (
            <rect
              key={rowIndex}
              x={rowIndex * (24 / value)}
              y="4"
              width={`${24 / value - 2}`}
              height="16"
              rx="2"
              ry="2"
              fill={imagesPerRow === value ? '#3BB7F3' : '#3BB7F3'}
            />
          ))}
      </svg>
    </button>
  ))}
</div>



      </div>

      {/* Progress Bar */}
      {loading && (
        <div className="progress-bar-container">
          <p>Loading... {progress}%</p>
          <div className="progress-bar">
            <div
              className="progress-bar-fill"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>
      )}

      {/* Render PDF Images in Grid */}
{/* Render either Images or Embedded PDF */}
{!loading && (
  showAsImages ? (
    <div
      className="pdf-grid"
      style={{
        gridTemplateColumns: `repeat(${imagesPerRow}, 1fr)`,
      }}
    >
      {pdfImages.map((image, index) => (
        <div
          key={index}
          className="pdf-image-container"
          onContextMenu={(e) => e.preventDefault()}
        >
          <img src={image} alt={`Page ${index + 1}`} />
          <div className="page-number">Page {index + 1}</div>
        </div>
      ))}
    </div>
  ) : (
    <iframe
      title="PDF Viewer"
      src={`https://api.notesmania.in/serve-pdf.php?file=${encodeURIComponent(pdfItem.file_path)}`}
      width="100%"
      height="800px"
      style={{ border: "none" }}
    />
  )
)}

    </div>
  );
};

export default PdfDetails;
